import type {CSSObject} from '@mui/material/styles';

const CTA_FOCUS_RING_OVERLAY: CSSObject = {
    content: '""',
    position: 'absolute',
    top: -6,
    left: -6,
    right: -6,
    bottom: -6,
    border: '2px solid var(--focus-state-blue)',
    borderRadius: '4px',
    pointerEvents: 'none',
}

/**
 * Focus ring drawn around a call to action. Pass the pseudo selector that should carry the overlay:
 * '&:focus-visible::after' for elements that receive focus themselves, '&::after' for a visual
 * button inside a card whose surrounding link is focused.
 */
export const ctaFocusRing = (pseudoSelector: string = '&::after'): CSSObject => ({
    position: 'relative',
    [pseudoSelector]: CTA_FOCUS_RING_OVERLAY,
})
